import { create } from 'zustand';

const useApiTypes = create((set) => ({
    apiTypes: [],
    setApiTypes: (apiTypes) => set(() => ({ apiTypes })),
}));

export default useApiTypes;
